<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import storePolicy from '@store/policy';
import {
  finalCalculationCH,
  IFinalCalculation,
} from '../../../../../helpers/finalCalculationCH';
import GeoRefChileRepository from '@repositories/geoRefChile.repository';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
const emit = defineEmits(['submitRFC']);

const store = storePolicy();
const refForm2 = ref<any>(null);
const finalCalculation = ref<IFinalCalculation | null>(null);
const fieldsForm2: any = ref([
  {
    key: 'tradeName',
    title: t('landing.forms.form_client_cl.nombre_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_cl.nombre_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    formatValue: (e: string) => e?.toUpperCase() ?? '',
  },
  {
    key: 'email',
    title: t('landing.forms.form_client_cl.email_del_cliente'),
    type: 'email',
    validations: {
      rules: {
        required: true,
        email: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
		 email: t('global.email_invalido'),
	  },
    },
    placeholder: t('landing.forms.form_client_cl.email_del_cliente'),
    value: store.data.email ?? null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'phone1',
    title: t('landing.forms.form_client_cl.telefono_del_cliente'),
    type: 'text',
    placeholder: t('landing.forms.form_client_cl.telefono_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'companyGPSId',
    title: t('landing.forms.form_client_cl.empresa_gps'),
    selectLabel: null,
    type: 'select',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    disabled: false,
    placeholder: t('landing.forms.form_client_cl.empresa_gps'),
    value: null,
    cols: 12,
    customClass: 'inputSelect',
    options: [],
  },
  {
    key: 'address',
    title: t('landing.forms.form_client_cl.direccion_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_cl.direccion_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'postCode',
    title: t('landing.forms.form_client_cl.codigo_postal'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_cl.codigo_postal'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'region',
    title: t('landing.forms.form_client_cl.region'),
    selectLabel: null,
    type: 'select',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_cl.region'),
    value: null,
    cols: 12,
    customClass: 'inputSelect',
    options: [],
    listenSelect: true,
  },
  {
    key: 'comuna',
    title: t('landing.forms.form_client_cl.comuna'),
    type: 'select',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.forms.form_client_cl.comuna'),
    value: null,
    options: [],
    cols: 12,
    customClass: 'inputSelect',
  },
]);

onMounted(async () => {
  const regiones = await GeoRefChileRepository.getRegiones();

  fieldsForm2.value = fieldsForm2.value.map((field: any) => {
    if (field.key === 'region') {
      field.options = regiones;
    }

    return field;
  });
});

const updateFieldsInArray = (
  array: any,
  updates: any,
  preservedValues: any,
) => {
  for (const update of updates) {
    const field = array.find((field: any) => field.key === update.key);
    if (field) {
      if ('value' in update) {
        field.value = update.value;
      }
      if ('options' in update) {
        field.options = update.options;
      }
      if ('disabled' in update) {
        field.disabled = update.disabled;
      }
    }
  }

  if (preservedValues) {
    for (const key in preservedValues) {
      const field = array.find((field: any) => field.key === key);
      if (field) {
        field.value = preservedValues[key];
      }
    }
  }
};

const handleGetCities = async () => {
  const { items } = await refForm2.value.getValues();

  const comunas = await GeoRefChileRepository.getComunas(items.region.id);
  await refForm2.value.setValue({ key: 'comuna', value: null });

  const preservedValues = {
    tradeName: items.tradeName,
    email: items.email,
    phone1: items.phone1,
    companyGPSId: items.companyGPSId,
    address: items.address,
    region: items.region,
  };

  updateFieldsInArray(
    fieldsForm2.value,
    [{ key: 'comuna', options: comunas, value: null }],
    preservedValues,
  );

  finalCalculation.value = finalCalculationCH(
    store.data.endPrice,
    store.pricing.uf,
  );
};

defineExpose({
  fieldsForm2,
  handleGetCities,
  updateFieldsInArray,
  getValues: () => refForm2.value?.getValues(),
});
</script>

<template>
  <Form ref="refForm2" :inputs="fieldsForm2" @select="handleGetCities"></Form>
</template>
